import { cx } from '@linaria/core';
import { useCallback, useState } from 'react';
import { AccessCodes } from '@pm2/api';
import { shouldTerminateMegaMenu } from '@pm2/sitemap-utils';
import { Link } from '@provider/navigation';
import { useLoaderState, Chevron } from '@utils/react';
import { leftNavCls, linkCls, stateWrapperCls, throbberCls, throbberWrapperCls, chevronCls, buttonItemCls } from './atom.left-nav.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const MegaMenuLeftNav = ({
  rootDescriptor,
  selectedDescriptor,
  onNavigate
}) => {
  const navItems = rootDescriptor?.children ?? [];
  navItems.filter(item => item.accessCode === AccessCodes.ALLOWED).findIndex(it => it === selectedDescriptor);
  return /*#__PURE__*/jsx("ul", {
    className: leftNavCls,
    children: navItems.filter(it => it.accessCode === AccessCodes.ALLOWED && !it.hidden).map(it => shouldTerminateMegaMenu(it) ? /*#__PURE__*/jsx(NavTerminateLink, {
      itemDescriptor: it,
      onNavigate: onNavigate
    }, it.id) : /*#__PURE__*/jsx(NavItem, {
      itemDescriptor: it,
      selected: selectedDescriptor === it,
      onNavigate: onNavigate
    }, it.id))
  });
};
const NavItem = ({
  itemDescriptor,
  selected,
  onNavigate
}) => {
  const [isLoading, setLoading] = useState(false);
  const showThrobber = useLoaderState(isLoading);
  const onClick = async evt => {
    if (selected) {
      return;
    }
    setLoading(true);
    try {
      await onNavigate(evt, itemDescriptor, true);
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/jsx("li", {
    children: /*#__PURE__*/jsxs("button", {
      className: cx(buttonItemCls, linkCls, selected && "selected"),
      onClick: onClick,
      children: [itemDescriptor.title, /*#__PURE__*/jsxs("span", {
        className: stateWrapperCls,
        children: [/*#__PURE__*/jsx("span", {
          className: cx(throbberWrapperCls, !showThrobber.current && "hidden"),
          children: /*#__PURE__*/jsx("span", {
            className: throbberCls
          })
        }), /*#__PURE__*/jsx("span", {
          className: cx(chevronCls, showThrobber.current && "hidden"),
          children: /*#__PURE__*/jsx(Chevron, {
            size: 8,
            lineWidth: 1.5
          })
        })]
      })]
    })
  });
};
const NavTerminateLink = ({
  itemDescriptor,
  onNavigate
}) => {
  const onClick = useCallback(async evt => {
    await onNavigate(evt, itemDescriptor, true);
  }, [itemDescriptor, onNavigate]);
  return /*#__PURE__*/jsx("li", {
    children: /*#__PURE__*/jsx(Link, {
      className: linkCls,
      href: itemDescriptor.path,
      onClick: onClick,
      children: itemDescriptor.title
    })
  });
};

export { MegaMenuLeftNav };
//# sourceMappingURL=atom.left-nav.js.map
